<template>
    <div class="change-password">
        <h2 class="change-password__header" v-html="$t('PasswordChange.header')"></h2>
        <template v-if="!passwordChanged">
            <div>
                <TotemPasswordInput v-model="$v.oldPassword.$model" :label="$t('PasswordChange.old_password')" :fullWidth="true" :disabled="sending" isRequired />
                <totem-form-finnish-label-error :field="$v.oldPassword" :label="$t('General.password')"/>
            </div>
            <div>
                <TotemPasswordInput v-model="$v.newPassword.$model" :label="$t('PasswordChange.new_password')" :fullWidth="true" :disabled="sending" isRequired />
                <totem-form-finnish-label-error :field="$v.newPassword" :label="$t('General.password')"/>
            </div>
            <div>
                <TotemPasswordInput v-model="$v.newPasswordAgain.$model" :label="$t('PasswordChange.new_password_again')" :fullWidth="true":disabled="sending" isRequired/>
                <totem-form-finnish-label-error :field="$v.newPasswordAgain" :label="$t('General.password')"/>
            </div>
            <div class="change-password__button-container">
                <TotemButton
                    v-on:click="requestPasswordChange"
                    color="primary"
                    size="medium"
                    :disabled="sending"
                    class="change-password__button"
                    :label="$t('PasswordChange.submit')"
                />
            </div>
        </template>
        <div class="change-password__error" v-html="error" v-if="error"></div>
        <template v-if="passwordChanged">
            <p class="change-password__change-success" v-html="$t('PasswordChange.success')"></p>
            <p class="change-password__change-success-instruction" v-html="$t('PasswordChange.success_instruction')"></p>
        </template>
    </div>
</template>

<script>
    import { validationMixin } from 'vuelidate'
    const { required, minLength, sameAs } = require('vuelidate/lib/validators')

    export default {
        props: {
            hasPassword: {
                type: Boolean,
                required: true,
            }
        },
        mixins: [validationMixin],
        validations: {
            oldPassword: {
                required
            },
            newPassword: {
                required,
                minLength: minLength(8)
            },
            newPasswordAgain: {
                repeatPassword: sameAs('newPassword')
            }
        },
        data () {
            return {
                passwordInfo: {},
                oldPassword: this.hasPassword ? null : 'old-dummy-password',
                newPassword: null,
                newPasswordAgain: null,
                passwordFieldType: 'password',
                sending: false,
                passwordChanged: false,
                error: null
            }
        },
        methods: {
            handleError (errorCode) {
                this.sending = false
                if (errorCode === 380) {
                    this.error = this.$t('PasswordChange.wrong_old_password')
                    return
                }
                this.error = this.$t('General.sth_went_wrong')
            },
            async requestPasswordChange (e) {
                this.error = null
                this.$v.$touch()
                if (this.$v.$invalid) {
                    e.preventDefault()
                } else {
                    this.sending = true
                    let passwordInfo = {
                        oldPlainPassword: this.oldPassword,
                        newPlainPassword: this.newPassword
                    }
                    try {
                        await this.$store.dispatch('User/changePasswordFromUserInfo', passwordInfo)
                        this.passwordChanged = true
                    } catch (error) {
                        this.handleError(error.response.data.error.code)
                    }
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .change-password {
        display: flex;
        flex-direction: column;
        gap: 20px;
        height: 100%;
        max-width: 382px;
        width: 100%;

        &__header {
            font-size: 1.8rem;
            font-family: PlusJakartaSans-Medium, sans-serif;

            [class*="desktop"] & {
                font-size: 2rem;
            }
        }

        &__change-success {
            font-size: 2rem;
            color: $green;
            font-family: Nunito-Bold, sans-serif;
        }

        &__change-success-instruction {
            font-size: 1.8rem;
        }

        &__error {
          margin: 20px 0 0 0;
        }
    }
</style>
